import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { ShortUrl } from '@air/api';

const getPublicAudioSampleRatesListKey = ({
  shortId,
  boardId,
}: {
  shortId: string | undefined;
  boardId: string | undefined;
}) => ['PUBLIC_AUDIO_SAMPLE_RATES', { shortId, boardId }];

export const usePublicAudioSampleRatesList = ({
  shortId,
  boardId,
}: {
  shortId: string;
  boardId: string | undefined;
}) => {
  const key = getPublicAudioSampleRatesListKey({ shortId, boardId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(shortId, 'Short ID is required');

      const data = await ShortUrl.getAssetVersionFilterLookups({
        limit: 50,
        shortId,
        field: 'audioSampleRate',
        descendantBoardId: boardId,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!shortId,
  });
};
